/** Goal Types */
export const GET_LIBRARY_GOALS = 'GET_LIBRARY_GOALS';
export const GET_LIBRARY_GOALS_SUCCESS = 'GET_LIBRARY_GOALS_SUCCESS';

export const CREATE_LIBRARY_GOAL = 'CREATE_LIBRARY_GOAL';
export const EDIT_LIBRARY_GOAL = 'EDIT_LIBRARY_GOAL';
export const DELETE_LIBRARY_GOAL = 'DELETE_LIBRARY_GOAL';
export const CLONE_LIBRARY_GOAL = 'CLONE_LIBRARY_GOAL';

export const GET_LIBRARY_GOAL_BY_ID = 'GET_LIBRARY_GOAL_BY_ID';
export const GET_LIBRARY_GOAL_BY_ID_SUCCESS = 'GET_LIBRARY_GOAL_BY_ID_SUCCESS';

export const UPSERT_LIBRARY_SECTION_DESCRIPTION_BLOCK = 'UPSERT_LIBRARY_SECTION_DESCRIPTION_BLOCK';
export const DELETE_LIBRARY_SECTION_DESCRIPTION_BLOCK = 'DELETE_LIBRARY_SECTION_DESCRIPTION_BLOCK';

export const CREATE_LIBRARY_GOAL_TARGET = 'CREATE_LIBRARY_GOAL_TARGET';
export const EDIT_LIBRARY_GOAL_TARGET = 'EDIT_LIBRARY_GOAL_TARGET';
export const DELETE_LIBRARY_GOAL_TARGET = 'DELETE_LIBRARY_GOAL_TARGET';

export const REORDER_LIBRARY_GOAL_TARGET = 'REORDER_LIBRARY_GOAL_TARGET';

export const CREATE_LIBRARY_GOAL_OPTION = 'CREATE_LIBRARY_GOAL_OPTION';
export const EDIT_LIBRARY_GOAL_OPTION = 'EDIT_LIBRARY_GOAL_OPTION';
export const DELETE_LIBRARY_GOAL_OPTION = 'DELETE_LIBRARY_GOAL_OPTION';

export const REORDER_LIBRARY_GOAL_OPTION = 'REORDER_LIBRARY_GOAL_OPTION';

export const CHOOSE_TARGETS_FROM_LIBRARY_GOAL = 'CHOOSE_TARGETS_FROM_LIBRARY_GOAL';
export const CHOOSE_OPTIONS_FROM_LIBRARY_GOAL = 'CHOOSE_OPTIONS_FROM_LIBRARY_GOAL';

/** End */

/** Mastery */
export const CHANGE_LIBRARY_GOAL_TARGET_MASTERY = 'CHANGE_LIBRARY_GOAL_TARGET_MASTERY';
export const CHANGE_LIBRARY_GOAL_MASTERY = 'CHANGE_LIBRARY_GOAL_MASTERY';
export const CHANGE_SINGLE_LIBRARY_GOAL_TARGET_MASTERY = 'CHANGE_SINGLE_LIBRARY_GOAL_TARGET_MASTERY';
export const REMOVE_SINGLE_LIBRARY_GOAL_TARGET_MASTERY = 'REMOVE_SINGLE_LIBRARY_GOAL_TARGET_MASTERY';

/** End */

/** Target Maintenance */
export const CHANGE_LIBRARY_TARGET_MAINTENANCE = 'CHANGE_LIBRARY_TARGET_MAINTENANCE';
export const ADD_LIBRARY_TARGET_MAINTENANCE_STEP = 'ADD_LIBRARY_TARGET_MAINTENANCE_STEP';
export const EDIT_LIBRARY_TARGET_MAINTENANCE_STEP = 'EDIT_LIBRARY_TARGET_MAINTENANCE_STEP';
export const DELETE_LIBRARY_TARGET_MAINTENANCE_STEP = 'DELETE_LIBRARY_TARGET_MAINTENANCE_STEP';
/** End */

/** Single Target Maintenance */
export const CHANGE_SINGLE_LIBRARY_TARGET_MAINTENANCE = 'CHANGE_SINGLE_LIBRARY_TARGET_MAINTENANCE';
export const ADD_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP = 'ADD_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP';
export const EDIT_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP = 'EDIT_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP';
export const DELETE_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP = 'DELETE_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP';
export const SINGLE_LIBRARY_TARGET_FOLLOW_GOAL_CONFIG = 'SINGLE_LIBRARY_TARGET_FOLLOW_GOAL_CONFIG';
export const SINGLE_LIBRARY_TARGET_MASTERY_FOLLOW_GOAL = 'SINGLE_LIBRARY_TARGET_MASTERY_FOLLOW_GOAL';
/** End */

/** Clinical Library Folders */
export const GET_LIBRARY_FOLDERS = 'GET_LIBRARY_FOLDERS';
export const GET_LIBRARY_FOLDERS_SUCCESS = 'GET_LIBRARY_FOLDERS_SUCCESS';

export const CREATE_LIBRARY_FOLDER = 'CREATE_LIBRARY_FOLDER';
export const EDIT_LIBRARY_FOLDER = 'EDIT_LIBRARY_FOLDER';
export const DELETE_LIBRARY_FOLDER = 'DELETE_LIBRARY_FOLDER';
/** End */

/** Targets */
export const CREATE_LIBRARY_TARGET = 'CREATE_LIBRARY_TARGET';
export const EDIT_LIBRARY_TARGET = 'EDIT_LIBRARY_TARGET';
export const DELETE_LIBRARY_TARGET = 'DELETE_LIBRARY_TARGET';

/** End */

/** Options */
export const CREATE_LIBRARY_OPTION = 'CREATE_LIBRARY_OPTION';
export const EDIT_LIBRARY_OPTION = 'EDIT_LIBRARY_OPTION';
export const DELETE_LIBRARY_OPTION = 'DELETE_LIBRARY_OPTION';

/** End */
